/* eslint-disable */
export default `<div class="grouping-container">
    <header class="grouping-header">
        <h2 class="grouping-header__name">
            <%= data.name %>
        </h2>
    </header>
    <section class="results">
        <header class="results-header">
            <span class="results-header__element"><%= translator.translate('views.templates.racecards.market') %></span>
            <span class="results-header__element results-header__result"><%= translator.translate('views.templates.racecards.result') %></span>
        </header>
        <div class="results-content">
            <ul class="results-content__list">
                <% data.markets.forEach(function(market) { %>
                <li class="results-item">
              <span class="results-item__element results-item__name">
                <%= market.name %>
              </span>
                    <span class="results-item__element results-item__result">
                <%= market.selections[0].name %> (<%= market.selections[0].live_price.den %>/<%= market.selections[0].live_price.num %>)
              </span>
                </li>
                <% }); %>
            </ul>
        </div>
    </section>
</div>`;
